import { GuardTeamEquipmentLists } from "./equipment/GuardTeamEquipmentLists";

export const SecurityInventoryTab = () => {
  return <GuardTeamEquipmentLists />;
};